<template lang="pug">
  div
    menu-dropdown-analytics(:title="$t('loyalty.accounts')" linkTo="LoyaltyAnalytics")
    kpi-cards-accounts(v-if="tipCons && fechaHasta && appProgram" :datagraf="datagraf" :tipCons="tipCons" :fechaHasta="fechaHasta" :appProgram="appProgram" @type-cons='typeChanging')
    ods-module
      div(slot='header').clearfix
        span {{ $t('loyalty.accounts') }}
      div.text__item
        accounts-table(v-if="showTable" :tipCons="tipCons", :fechaHasta="fechaHasta", :appProgram="appProgram")
</template>

<script>
import LoyaltyDropDownAnalytics from '@/components/loyalty/LoyaltyDropDownAnalytics'
import KpiCardsAccounts from '@/components/loyalty/Analytics/KpiCardsAccounts'
import AccountsTable from '@/components/loyalty/Analytics/AccountsTable'
import { mapGetters } from 'vuex'

export default {
  name: 'AnalyticsAccounts',
  components: {
    'menu-dropdown-analytics': LoyaltyDropDownAnalytics,
    'kpi-cards-accounts': KpiCardsAccounts,
    'accounts-table': AccountsTable
  },
  data () {
    return {
      fechaHasta: null,
      tipCons: null,
      appProgram: null,
      datagraf: null,
      params: null,
      showTable: false
    }
  },
  computed: {
    ...mapGetters(['getFechaHasta', 'getSelectedProgram', 'analyticsBussy', 'getCLTCFloading'])
  },
  methods: {
    typeChanging (data) {
      if ((data && data.tipCons !== this.tipCons) || (data && data.refresh)) {
        this.showTable = false
        this.tipCons = data.tipCons
        setTimeout(() => {
          console.log('tipCons AA')
          this.showTable = true
        }, 800)
      }
    }
  },
  mounted () {
    // console.log(this.$route.params)
    this.datagraf = this.$route.params.datagraf
    this.fechaHasta = this.getFechaHasta
    this.appProgram = this.getSelectedProgram
    this.tipCons = 'T'
    // console.log(`this.getFechaHasta ${this.getFechaHasta} this.getSelectedProgram ${this.getSelectedProgram} this.tipCons ${this.tipCons}`)
    setTimeout(() => {
      console.log('mounted AA')
      this.showTable = true
    }, 800)
  },
  watch: {
    async getFechaHasta (newData, oldData) {
      if (newData) {
        this.showTable = false
        this.datagraf = null
        // console.log(`AC getFechaHasta ${newData} ${oldData}`)
        this.fechahasta = newData
        this.tipCons = 'T'
      }
    },
    async getSelectedProgram (newData, oldData) {
      if (newData) {
        this.showTable = false
        // console.log(`AC getSelectedProgram ${newData} ${oldData}`)
        this.appProgram = newData
      }
    }
  }
}
</script>
